import React, { forwardRef } from 'react';
import getMuiIcon, { IconName } from '../../../utils/getMuiIcon';
import { IconButton, IconButtonProps, SvgIcon, Tooltip } from '@mui/material';
import { palette } from '../../../assets/styles/themes/tokens';

export type AIAssistantIconButtonProps = {
  icon: IconName;
  tooltip?: string;
  iconSize?: 'medium' | 'large';
} & IconButtonProps;

const AIAssistantIconButton: React.FC<AIAssistantIconButtonProps> = forwardRef(
  ({ icon, tooltip, iconSize = 'medium', ...props }, ref) => {
    const iconSizePx = iconSize === 'medium' ? 24 : 32;

    const buttonStyles = {
      color: palette.text.secondary,
      '&:hover': {
        backgroundColor: palette.primary.hover,
        color: palette.primary.main,
      },
      ...props.sx
    };

    const button = (
      <IconButton 
        {...props} 
        sx={buttonStyles} 
        ref={ref}
        type={props.type || 'button'}
        aria-label={props['aria-label'] || tooltip || undefined}
      >
        <SvgIcon
          sx={{ width: iconSizePx, height: iconSizePx }}
          viewBox={`0 0 ${iconSizePx} ${iconSizePx}`}
          component={getMuiIcon(icon)}
          aria-hidden='true'
        /> 
      </IconButton>
    );

    return (
      tooltip ? (
        <Tooltip title={tooltip} placement='top' arrow>
          {button}
        </Tooltip>
      ) : (
        button
      )
    );
  });

export default AIAssistantIconButton;
